<template>
  <v-sheet>
    <v-table
        v-if="commands.length > 0"
        fixed-header
        height="500px"
    >
      <thead>
      <tr>
        <th style="width: 50%;"><h4>{{ $t('profile.command') }}</h4></th>
        <th style="width: 50%;"><h4>{{ $t('profile.permissions') }}</h4></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in commands" :key="index">
        <td>!{{ item.command }}</td>
        <td>{{ item.permissions.join(", ") }}</td>
      </tr>
      </tbody>
    </v-table>
  </v-sheet>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Backend } from '@/services/Backend';

const props = defineProps({
  kickletUser: Object,
});

const commands = ref([]);

onMounted(() => {
  Backend.getActiveCommandsPublic(props.kickletUser.id)
    .then(response => {
      commands.value = response.data;
    });
});
</script>

<style scoped>
</style>
